import scrollToComponent from 'react-scroll-to-component';

/**
 * Resolves a DOM Element from antd InputRef, HTMLElement, or similar ref shapes.
 * Avoids ReactDOM.findDOMNode throwing on antd 5 refs.
 */
export function resolveScrollElement(ref: unknown): Element | null {
  if (!ref) {
    return null;
  }

  if (ref instanceof Element) {
    return ref;
  }

  if (typeof ref !== 'object') {
    return null;
  }

  const candidate = ref as {
    nativeElement?: unknown;
    input?: unknown;
    resizableTextArea?: { textArea?: unknown };
  };

  if (candidate.nativeElement instanceof Element) {
    return candidate.nativeElement;
  }

  if (candidate.input instanceof Element) {
    return candidate.input;
  }

  if (candidate.resizableTextArea?.textArea instanceof Element) {
    return candidate.resizableTextArea.textArea;
  }

  return null;
}

export function scrollToInvalidField(ref: unknown): void {
  const element = resolveScrollElement(ref);

  if (!element) {
    return;
  }

  try {
    scrollToComponent(element);
  } catch {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
